<template>
  <div class="eventList">
    <h3 class="center title">“中国设计年度十大事件”候选事件</h3>
    <div class="container">
      <div class="add">
        <router-link class="bold" to="/top_events/form">提交推荐表</router-link>
        <span class="noteTxt">已提交（{{total}}）</span>
      </div>
      <div v-if="loading" class="note">
        <Icon class="turn" size="50" type="ios-loading" />
        <p>加载中...</p>
      </div>
      <template v-else>
        <template v-if="total>0">
          <Row :gutter="20">
            <Col v-for="l in list" :key="l.id" :lg="8" :md="12" :sm="24" :xs="24">
              
              <div class="info">
                <div class="ellipsis"><div class="label">事件名称：</div><div class="value">{{l.eventName}}</div></div>
                <div class="ellipsis"><div class="label">门类：</div><div class="value">{{l.type}} {{l.otherType}}</div></div>
                <div class="ellipsis"><div class="label">推荐人/单位：</div><div class="value">{{l.recommender}}</div></div>
                <div class="ellipsis"><div class="label">申报单位：</div><div class="value">{{l.applicant}}</div></div>
                <div class="ellipsis"><div class="label">负责人：</div><div class="value">{{l.chargePerson}}</div></div>
                <div class="ellipsis"><div class="label">联系电话：</div><div class="value">{{l.phone}}</div></div>
                <div>
                  <Tooltip :content="l.mainEvent" theme="light" max-width="100%" placement="bottom-start">
                    <span class="colorText">主要事迹</span>
                  </Tooltip>
                </div>
                <div>
                  <Tooltip :content="l.reason" theme="light" max-width="100%" placement="bottom-start">
                    <span class="colorText">推荐理由</span>
                  </Tooltip>
                </div>
                <div class="del"><span class="btnDel" @click="deleteEvent(l)">删除</span></div>
              </div>
            </Col>
          </Row>
          <div class="pageWrap">
            <Page :total="total" :current="page+1" @on-change="handlePageChange" :page-size="size" show-elevator show-total />
          </div>
        </template>
        <div v-else class="center">
          暂无候选事件
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import competitionService from "@/api/competition";
export default {
  data() {
    return {
      userInfo: this.$store.getters.userInfo || {},
      loading: false,
      total: 0,
      list: [],
      page: 0,
      size: 24
    };
  },
  mounted() {
    if (this.gIsLogin()) {
      this.getList();
    }
  },
  methods: {
    // 获取事件列表
    getList() {
      this.loading = true;
      let condition = {"userId.eq": this.userInfo.id}
      competitionService.getTopEvent(condition).then(res => {
        this.loading = false;
        if (res.errorNo == 0) {
          this.list = res.data;
          this.total = res.data.length;
        } else {
          this.$Message.error(res.errorMessage);
        }
      })
      .catch(() => {
        // this.$Message.error(err.message)
        this.loading = false;
        this.$Message.error("连接服务器失败，请稍后再试");
      });

    },
    // 删除事件
    deleteEvent(ev){
      this.$Modal.confirm({
        title: "删除事件",
        content: "确定要删除事件 “" + ev.eventName + "” 吗？",
        onOk: () => {
          competitionService
            .deleteOneTopEvent(ev.id)
            .then(res => {
              if (res.errorNo == 0) {
                this.$Message.info("删除事件成功");
                this.getList();
              } else {
                this.$Message.error(res.errorMessage);
              }
            })
            .catch(() => {
              // this.$Message.error(err.message)
              this.$Message.error("连接服务器失败，请稍后再试");
            });
        },
        onCancel: () => {
          // this.$Message.info('Clicked cancel');
        }
      });
    },
    // 翻页
    handlePageChange(page) {
      this.page = page - 1;
      this.loading = true;
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped>
.eventList {
  .title {
    padding: 15px 0 30px;
  }

  .note {
    padding: 10px 0;
    text-align: center;

    .turn {
      animation: turn 1s linear infinite;
      margin-bottom: 10px;
    }
    @keyframes turn {
      0% {
        -webkit-transform: rotate(0deg);
      }
      25% {
        -webkit-transform: rotate(90deg);
      }
      50% {
        -webkit-transform: rotate(180deg);
      }
      75% {
        -webkit-transform: rotate(270deg);
      }
      100% {
        -webkit-transform: rotate(360deg);
      }
    }
  }
  .add{
    padding: 5px;
  }
  .del{
    text-align: right;
  }
  .btnAdd{
    font-size: 16px;
  }
  .btnDel{
    cursor: pointer;
    color: #d42a1b;
  }
  .noteTxt{
    display: block;
    padding: 10px 0;
  }
  .info {
    padding: 15px;
    box-shadow: 0 0 10px 2px rgba($color: #000000, $alpha: 0.2);
    border-radius: 5px;
    margin-bottom: 20px;
  }
  .colorText{
    color: #2d8cf0;
    cursor: pointer;
  }
  .label {
    float: left;
    width: 95px;
    font-weight: 600;
  }
  .value {
    margin-left: 100px;
  }
  .pageWrap {
    text-align: right;
    padding: 20px 0 50px;
  }
}
</style>
